import {
  SIGN_IN,
  SIGN_OUT,
  LOGGED_IN,
  LOAD_SETTINGS,
  LOAD_TENANT,
  LOAD_COMPANY_PROFILE
} from '../actions/userActions'


export default function (state = { settings: null }, action) {
  switch (action.type) {
    case SIGN_IN:
      return { ...state, user: action.payload }
    case SIGN_OUT:
      return { ...state, user: null }
    case LOGGED_IN:
      return { ...state, user: action.payload }
    case LOAD_SETTINGS:
      return { ...state, settings: action.payload }
    case LOAD_TENANT:
      return { ...state, tenant: action.payload }
    case LOAD_COMPANY_PROFILE:
      return { ...state, companyProfile: action.payload}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/userReducer.js